import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'App/components'
import { createProcessingSelector, removeRequestRequest, REMOVE_REQUEST } from 'store'

export type TRemoveRequestDialogProps = {
  requestId: string
  advertId: string
}

const processingRequest = createProcessingSelector([REMOVE_REQUEST])

export const RemoveRequestDialog = (props: TRemoveRequestDialogProps) => {
  const dispatch = useDispatch()
  const processing = useSelector(processingRequest)

  const handleClick = () => {
    dispatch(removeRequestRequest(props))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>Are you sure you want to remove this request?</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            Remove
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
